import { LineItem } from '@commercelayer/sdk';
import { SiteLocale } from '@graphql/generated';
import t from '@lib/locales';
import { getFormattedAvailabilityText } from '@lib/utils/clUtils';
import { getShippingMessage } from '@utils/shipping-message';
import Image from 'next/image';
import { useEffect, useState } from 'react';
import { QuantitySelector } from './QuantitySelector';

type Props = {
  locale: SiteLocale;
  lineItem: LineItem;
  handleUpdateQuantity: (lineItem: LineItem, quantity: number) => Promise<void>;
  handleRemoveLineItem: (lineItem: LineItem) => Promise<void>;
  loading: boolean;
  daysLimit: number;
  qtTreshold: number;
};
const CartLineItem = ({
  locale,
  lineItem,
  handleUpdateQuantity,
  handleRemoveLineItem,
  loading,
  daysLimit,
  qtTreshold,
}: Props) => {
  const pic = lineItem.image_url;
  const levels = lineItem.metadata?.levels;
  const pageUrl = lineItem.metadata?.url || '#';
  const { quantity: initialQuantity } = lineItem;
  const [quantity, setQuantity] = useState<number>(initialQuantity);
  const [message, setMessage] = useState(null);

  const updateQuantity = () => {
    return handleUpdateQuantity(lineItem, quantity);
  };

  const removeLineItem = () => {
    return handleRemoveLineItem(lineItem);
  };

  useEffect(() => {
    async function fetchMessage() {
      const message = await getShippingMessage(locale);
      setMessage(message);
    }
    fetchMessage();
  }, []);

  return (
    <div className="cart_line">
      {pic && (
        <a href={pageUrl} className="cart_line-item__image">
          <Image src={pic} alt={lineItem.name} width={170} height={170} />
        </a>
      )}
      <div className="cart_line-item">
        <div className="cart_line-item__name">
          <a href={pageUrl}>{lineItem.name}</a>
          <button
            type="button"
            disabled={loading}
            className="cart_line-item__remove"
            onClick={removeLineItem}
          >
            {t(locale, 'remove')}
          </button>
        </div>

        <div className="cart_line-item__amount">
          <div>{t(locale, 'amount')}:</div>
          <span>{lineItem.formatted_unit_amount}</span>
        </div>

        {levels && levels.length > 0 && (
          <div className="cart_line-item__availability">
            {!!message
              ? message
              : getFormattedAvailabilityText(
                  levels,
                  locale,
                  daysLimit,
                  qtTreshold,
                  lineItem.quantity
                )}
          </div>
        )}

        <div className="cart_line-quantity">
          <div className="cart_line-item__change-quantity">
            <QuantitySelector
              quantity={quantity}
              lineItem={lineItem}
              handleChange={(event: any) => {
                setQuantity(parseInt(event.target.value));
              }}
            />
          </div>
          <div className="cart_line-item__total-amount">{lineItem.formatted_total_amount}</div>
        </div>

        <div className="cart_line-end">
          <div className="cart_line-item__quantity">
            {t(locale, 'quantity')}: {lineItem.quantity}
          </div>
        </div>

        <div>
          <button
            type="button"
            className={'button--update-cart' + (initialQuantity == quantity ? ' invisible ' : '')}
            onClick={() => updateQuantity()}
            disabled={loading}
          >
            {t(locale, 'update_cart')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CartLineItem;
